export interface ScreenshotTemplate {
  id: string;
  app: "classic" | "ai";
  headline: string;
  subtitle: string;
  gradient: string;
  textColor: string;
}

export const PRESET_GRADIENTS = [
  { id: "classic-warm", label: "Classic Warm", value: "linear-gradient(160deg, #ff6b00, #ff9500)" },
  {
    id: "classic-fire",
    label: "Classic Fire",
    value: "linear-gradient(160deg, #ff4500, #ff6b00)",
  },
  {
    id: "classic-sunset",
    label: "Classic Sunset",
    value: "linear-gradient(160deg, #ff6b00, #ffd700)",
  },
  { id: "ai-blue", label: "AI Blue", value: "linear-gradient(160deg, #0071e3, #6e3eff)" },
  { id: "ai-neon", label: "AI Neon", value: "linear-gradient(160deg, #00d4ff, #0071e3)" },
  { id: "ai-deep", label: "AI Deep", value: "linear-gradient(160deg, #1a0040, #6e3eff)" },
] as const;

export const TEMPLATES: ScreenshotTemplate[] = [
  {
    id: "classic-hero",
    app: "classic",
    headline: "Shot Counting\nMade Simple",
    subtitle: "Track every shot with one tap",
    gradient: PRESET_GRADIENTS[0].value,
    textColor: "#ffffff",
  },
  {
    id: "classic-voice",
    app: "classic",
    headline: "Hands-Free\nVoice Control",
    subtitle: "Count shots without touching your phone",
    gradient: PRESET_GRADIENTS[1].value,
    textColor: "#ffffff",
  },
  {
    id: "classic-stats",
    app: "classic",
    headline: "Practice Stats\nat a Glance",
    subtitle: "See your shooting percentage instantly",
    gradient: PRESET_GRADIENTS[2].value,
    textColor: "#ffffff",
  },
  {
    id: "ai-hero",
    app: "ai",
    headline: "AI-Powered\nShot Analysis",
    subtitle: "Understand why you miss, not just how many",
    gradient: PRESET_GRADIENTS[3].value,
    textColor: "#ffffff",
  },
  {
    id: "ai-error",
    app: "ai",
    headline: "Error\nClassification",
    subtitle: "Arc, Depth, Direction analysis for every miss",
    gradient: PRESET_GRADIENTS[4].value,
    textColor: "#ffffff",
  },
  {
    id: "ai-timeline",
    app: "ai",
    headline: "Heart Rate\n& Timeline",
    subtitle: "See biometrics alongside your practice data",
    gradient: PRESET_GRADIENTS[5].value,
    textColor: "#ffffff",
  },
];

export function getTemplatesForApp(app: "classic" | "ai"): ScreenshotTemplate[] {
  return TEMPLATES.filter((t) => t.app === app);
}
